import { NgTemplateOutlet } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { outputFromObservable } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

import { MockEditService } from '../../../mock';
import { FormlyButtonDropdown, GridPreviousNext, SummaryButton, SummaryItem } from '../../../models';
import { BaseEditCreateService, BaseEditService } from '../../../services';
import { SummaryTopComponent } from '../../summary-top/summary-top.component';

@Component({
  selector: 'app-tab-form-modal',
  templateUrl: './tab-form-modal.component.html',
  styleUrl: './tab-form-modal.component.scss',
  imports: [SummaryTopComponent, NgTemplateOutlet],
})
export class TabFormModalComponent {
  protected saveClicked$ = new Subject<void>();

  public readonly header = input<string>();
  readonly model$ = input<Observable<any>>();
  public readonly showCopy = input(false);
  public readonly showSave = input(true);
  public readonly showBack = input(true);
  public readonly summaryItems = input<(model: any) => SummaryItem[]>();
  public readonly baseService = input<BaseEditService<any, any> | BaseEditCreateService<any, any>>(
    new MockEditService(),
  );
  public readonly isModal = input(true);
  public readonly copyButtonText = input($localize`Copy`);
  public readonly enableCopyButton = input(true);
  // A mix is allowed - the summary bar draws each by its own kind.
  public readonly additionalButtons = input<(SummaryButton | FormlyButtonDropdown)[]>();
  public readonly createDropdown = input<FormlyButtonDropdown>();
  // Previous / Next for a modal that edits one of a list of sibling records (order lines):
  // the host supplies the neighbours' ids and moves to the one emitted. Left unset, the header
  // shows no arrows in a modal, as before.
  public readonly previousNext = input<GridPreviousNext>();
  public readonly movePrevious = output<string>();
  public readonly moveNext = output<string>();
  public readonly copyModel = output<void>();
  public readonly saveClicked = outputFromObservable<void>(this.saveClicked$);
}
